import { $api } from '@shared/api';
import { IReturnResponse } from '@widgets/Files/model/types/api.interface';
import { TFileId } from '@widgets/Files/model/types/fileId.type';

interface IRenameFileParams {
    fileId: TFileId;
    newName: string;
}

export const renameFile = async ({ fileId, newName }: IRenameFileParams) => {
    // @ts-ignore
    const route = routable.getRoute('renameFile').replace('_attachmentId_', fileId);
    try {
        const formData = new FormData();
        formData.append('name', newName);
        const { data } = await $api.post<IReturnResponse>(route, formData);
        return data;
    } catch (error) {
        console.error('rename file failed:', error);
        return error;
        // return {
        //     status: 'error',
        //     data: null,
        //     message: error.message,
        // };
    }
};
